<template>
  <div v-if="item">
    <div class="flex">
      <div class="pack">
        {{ item.label }}
      </div>
      <!-- <div v-if="item.off" class="off" :class="{ 'laptop:!-left-1': isSmall }">
        <div>%{{ item.off }}</div>
        <div class="-mt-2">OFF</div>
      </div> -->
    </div>
    <div class="text-sm text-center mb-2 mt-4">{{ item.title }}</div>
    <div class="flex flex-col items-center">
      <span
        class="flex items-center justify-center"
        :class="
          item.off
            ? 'line-through decoration-[#FB977D] text-blue-400'
            : ''
        "
      >
        <span :class="item.off ? '' : 'text-xl font-extrabold'">
          {{ formatPrice(item.price) }}
        </span>
        <span class="ms-1" :class="item.off ? 'text-sm' : ''">تومان</span>
      </span>

      <div
        v-if="item.off"
        class="flex align-center justify-center bg-[#F84C20] text-white rounded-2xl px-4 py-1 my-4 text-sm"
      >
        {{ item.off }}% تخفیف
      </div>

      <span v-if="item.off" class="flex items-center justify-center">
        <span class="ml-1 text-xl font-extrabold">
          {{ getOffPrice(item.price, item.off) }}
        </span>
        <span class="ms-1">تومان</span>
      </span>
      <div v-if="item.setupFee" class="text-sm">
        <div class="text-center">+</div>
        <div class="text-center mt-4">
          {{ formatPrice(item.setupFee) }}<span class="ms-1">تومان</span>
        </div>
        <div class="text-center">هزینه راه‌اندازی</div>
      </div>
    </div>

    <slot name="buttons"></slot>
    <div v-if="!slots.buttons" class="mt-4">
      <BaseButton
        isLean
        size="full"
        text="ثبت سفارش"
        @click="showMainModal"
        class="rounded-lg h-[32px]"
      />
      <NuxtLink v-if="shoppingSrc" :to="shoppingSrc">
        <BaseButton
          size="full"
          text="خرید آنلاین"
          styleType="secondary"
          class="rounded-lg h-[32px] mt-2"
        />
      </NuxtLink>
    </div>

    <div v-if="item.options" class="flex flex-col my-4 gap-3">
      <div
        class="flex justify-start text-sm"
        v-for="i in item.options"
        :key="'bo' + i.id"
      >
        <div class="me-2">
          <IconLightTik class="stroke-blue-700 scale-100 ml-2 h-6" />
        </div>
        <div class="text-gray-500">{{ i.title }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSlots } from "vue";

defineProps({
  item: Object,
  shoppingSrc: {
    type: String,
    default: "",
  },
});

const { formatPrice } = useInputHelpers();

const roundToNearestHundredThousand = (value) => {
  return Math.round(value / 1000) * 1000;
};

const getOffPrice = (price, off) => {
  const totalPrice = (price * off) / 100;
  const offPrice = roundToNearestHundredThousand(price - totalPrice);
  return formatPrice(offPrice);
};

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};

const slots = useSlots();
</script>
